import { tosaToken } from '@farmersdog/lead-browser-storage';

export function useTosaAuthToken() {
  return tosaToken.get();
}
